import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { onChangeEvent } from "../reactive-events/onChange";
import { checkFormValidity } from "../../form-store/action-types";
import "react-phone-input-2/lib/style.css";
import "./index.scss";

const Phone = props => {
  const { name, label } = props;
  const [phone, setPhone] = useState("");
  const dispatch = useDispatch();

  const formObj = useSelector(({ form }) => form[form.currentForm]);

  useEffect(() => {
    let defPhone = formObj && formObj.hasOwnProperty(name) ? formObj[name] : "";
    setPhone(defPhone.number || "");
    let _valid = phone === "" ? "Please provide a valid number" : "";
    document.querySelector('[type="tel"]').setCustomValidity(_valid);
  }, [formObj, setPhone, name, phone]);

  const onChange = (value, country, e, formattedValue) => {
    let _tmpObj = {
      number: value,
      isdnCode: country.dialCode,
      countryCode: country.countryCode,
    };
    dispatch(onChangeEvent(name, _tmpObj));
    let _valid = value.replace(country.dialCode, "") === "" ? "Please provide a valid number" : "";
    document.querySelector('[type="tel"]').setCustomValidity(_valid);
    setTimeout(() => dispatch(checkFormValidity()), 1);
    setPhone(value);
  };

  return (
    <div style={{ gridArea: name }}>
      <p className="sisp-label sisp-input--required">{label || "Phone number"}</p>

      <PhoneInput
        key="phoneNumber"
        inputProps={{
          name: "phone",
          required: true,
          autoFocus: true,
          dataphone: phone === "" ? "empty" : "",
        }}
        country="us"
        enableAreaCodes={true}
        countryCodeEditable={false}
        defaultCountry={"us"}
        value={phone}
        onChange={onChange}
        excludeCountries={['ru', 'by']}
      />
    </div>
  );
};

export default Phone;
